module.exports = __webpack_public_path__ + "static/luke-73e1201b526d713e151472846b62f494.jpeg";